import { HttpClient, HttpEvent, HttpEventType } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { FlowQueryModel, UserQueryModel } from "src/app/models/flowquerymodel";
import { FlowServiceService } from "src/app/Services/flow-service.service";
import { MediaUploadService } from "src/app/Services/media-upload.service";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-create-about-us",
  templateUrl: "./create-about-us.component.html",
  styleUrls: ["./create-about-us.component.scss"],
})
export class CreateAboutUsComponent implements OnInit {
  noResultReturned: boolean;
  isLoading: boolean;
  showImage: boolean;
  coverPageURI: string;
  sffilename: any;
  heading: string;
  editingKeys: Set<string> = new Set<string>();
  userData: any;
  showVideo: boolean;
  coverPosterPageURI: string;
  headingPageObj: any;
  whatPageObj: any;
  extraHeadingPageObj: any;
  whyparaPageObj: any;
  howPageObj: any;
  communityPageObj: any;
  version: any;
  versionList: string[] = [];
  allVersionsData: any[] = [];
  constructor(
    private toastManager: ToastrService,
    private http: HttpClient,
    private flowServiceService: FlowServiceService,
    private mediaUploadService: MediaUploadService
  ) {}
  async ngOnInit(): Promise<void> {
    this.userData = JSON.parse(localStorage.getItem("LoggedInUser"));
    if (this.userData) {
      await this.getAboutUs();
    }
    // this.heading = this.headingPageObj.heading?.replace(/<[^>]*>/g, "") || "";
    // this.whatPageObj.paraText =
    //   this.whatPageObj.paraText?.replace(/<[^>]*>/g, "") || "";
  }
  // whatPageObj = {
  //   imageUrl:
  //     "https://easycmstest.azureedge.net/mediaimage/20cf9e6cbfe74d65ba5451bf265b1f61.jpg",
  //   paraText: `<p class="ql-align-center">We are transforming the online video landscape, and with our step-by-step niche DIY guides platform, you no longer have to limit yourself to old-school paper manual guides and long explainer videos.</p><p class="ql-align-center">With the Flowchest app, you can create branded DIY guides that provide detailed but short step by step quality learning experience for your audience and customers. This way, your customers won't have to worry about skipping steps in an assembly/installation process, and your audience will have a sense of ease in knowing your DIY guide can be easily followed and practiced.</p>`,
  // };

  // howPageObj = {
  //   videoUrl: `https://easycmstest.azureedge.net/mediavideo/65d1dc7f3b89496592d3824d169c5987.mp4`,
  //   paraText: `<p class="ql-align-center">With Flowchest, you have everything you need to create interesting step by step DIY instructions. Paper manual guides are becoming obsolete due to the hassle that comes with following bulky content or having to keep your manual safe for future use. Video guides can also be enormously lengthy and confusing to follow or catch up with.</p><p class="ql-align-center">With the Flowchest, all that your audience or customers need to access your content is the in-app generated QR code, which can be used anytime, anywhere, and on any device. Furthermore, you can update or recreate the content at any time without having to change the hyperlink, therefore nobody will ever lose access after update.</p>`,
  //   imageCardWithLinkModels: [
  //     {
  //       title: "PlayStore",
  //       iconName: "",
  //       description: "",
  //       link: "https://play.google.com/store/apps/details?id=com.shnewframework.Flowchest&pli=1",
  //       imageUrl:
  //         "https://easycmstest.azureedge.net/mediaimage/a6659932bef2447b832f3adee3be0b29.png",
  //       partitionKey: "2516792950705964513",
  //       rowKey: "2516792950701149328",
  //       displayOrder: 0,
  //       isValid: true,
  //       version: "V5",
  //       errorMessage: null,
  //       status: null,
  //       timestamp: null,
  //     },
  //     {
  //       title: "AppleStore",
  //       iconName: "",
  //       description: "",
  //       link: "https://apps.apple.com/gb/app/flowchest/id1606597068",
  //       imageUrl:
  //         "https://easycmstest.azureedge.net/mediaimage/e40d80d3620b49a1b12e2ef018ad55c6.png",
  //       partitionKey: "2516792950705964513",
  //       rowKey: "2516792950693260126",
  //       displayOrder: 1,
  //       isValid: true,
  //       version: "V5",
  //       errorMessage: null,
  //       status: null,
  //       timestamp: null,
  //     },
  //   ],
  // };
  // headingPageObj = {
  //   heading:
  //     "<p>We are changing the way businesses, and content creators get their how-to DIY messages across to their customers and audience.</p>",
  //   partitionKey: "2516930912167041308",
  //   rowKey: "2516930912145576794",
  //   displayOrder: 1,
  //   isValid: true,
  //   version: "V5",
  //   errorMessage: null,
  //   status: "Published",
  //   timestamp: null,
  // };
  // extraHeadingPageObj = {
  //   heading: `<p class="ql-align-center">“Redefining How-to DIY Guides Content Creation”</p>`,
  // };

  // whyparaPageObj = [
  //   {
  //     tabName: "Quality Content",
  //     paragraphText:
  //       '<p class="ql-align-center">To keep your customers and audience, you need How-to DIY guides that are of high quality and captures the real intention of the guide. That\'s what you can do with Flowchest.</p>',
  //     partitionKey: "2516792952224733394",
  //     rowKey: "2516792952219540455",
  //     displayOrder: 0,
  //     isValid: true,
  //     version: "V3",
  //     errorMessage: null,
  //     status: null,
  //     timestamp: null,
  //   },
  //   {
  //     tabName: "Comprehensive and Engaging",
  //     paragraphText:
  //       '<p class="ql-align-center">As a content creator or product manufacturer, your DIY guides need to not only have immense value but also be endlessly engaging to keep the viewer interested and attentive</p>',
  //     partitionKey: "2516792952224733394",
  //     rowKey: "2516792952211839785",
  //     displayOrder: 1,
  //     isValid: true,
  //     version: "V3",
  //     errorMessage: null,
  //     status: null,
  //     timestamp: null,
  //   },
  //   {
  //     tabName: "More Value and Revenue",
  //     paragraphText:
  //       '<p class="ql-align-center">Producing value-laden how-to DIY videos is a great way to gain higher ROI and increase your audience reach. People buy more when they know they have all the guidance they need to succeed in the endeavor.</p>',
  //     partitionKey: "2516792952224733394",
  //     rowKey: "2516792952203903434",
  //     displayOrder: 2,
  //     isValid: true,
  //     version: "V3",
  //     errorMessage: null,
  //     status: null,
  //     timestamp: null,
  //   },
  // ];
  // communityPageObj = {
  //   paraText: `<p class="ql-align-center">&nbsp;As the end user, you get the benefit of having a central point where you can find all easy how-to guides from diverse content creators and businesses in one place, for everyday use. The end user can engage with the content creators and other users within the app, save content for future use and share with friends and families. We have a huge list of nice to have features in our backlog to further enhance user experience.</p>`,
  //   imageCardWithLinkModels: [
  //     {
  //       title: "Instagram",
  //       iconName: "",
  //       description: "Join us on Instagram",
  //       link: "https://www.instagram.com/flowchest.app/?utm_medium=copy_link",
  //       imageUrl:
  //         "https://easycmstest.azureedge.net/mediaimage/78155df1ce8d47aeaa5627a0f6e6ac2f.png",
  //       partitionKey: "2516969115998629501",
  //       rowKey: "2516969115956587513",
  //       displayOrder: 0,
  //       isValid: true,
  //       version: "V1",
  //       errorMessage: null,
  //       status: null,
  //       timestamp: null,
  //     },
  //   ],
  // };
  fileName: string = "";
  progress: number = 0;

  posterURI: any;
  fileData: File;
  currentEditingSection: string | null = null;
  startEditing(key: string): void {
    this.editingKeys.add(key);
  }

  isEditing(key: string): boolean {
    return this.editingKeys.has(key);
  }

  getAboutUs() {
    var flowQueryModel = new UserQueryModel({
      userEmail: this.userData.partitionKey,
      Status: "V1",
    });
    this.flowServiceService
      .getAboutUsDetails(flowQueryModel)
      .subscribe((data) => {
        this.noResultReturned = false;
        console.log(data);
        if (data) {
          this.allVersionsData = data;

          // Extract all versions
          this.versionList = data
            .map((item: any) => item.version)
            .filter(Boolean);

          // select current or latest version initially
          const currentVersionData =
            data.find((d) => d.isCurrentAboutUs) || data[0];
          this.version = currentVersionData.version;
          this.loadVersionData(currentVersionData);
        }
      });
  }

  onVersionChange() {
    const selectedVersionData = this.allVersionsData.find(
      (d) => d.version === this.version
    );
    if (selectedVersionData) {
      this.loadVersionData(selectedVersionData);
      this.toastManager.info(`${selectedVersionData} is selected`);
    }
  }

  loadVersionData(data: any) {
    this.headingPageObj = data.headingPageObj;
    this.whatPageObj = data.whatPageObj;
    this.extraHeadingPageObj = data.extraHeadingPageObj;
    this.whyparaPageObj = data.whyparaPageObj;
    this.howPageObj = data.howPageObj;
    this.communityPageObj = data.communityPageObj;
  }

  showConfirmPopup = false;
  pendingSaveVersion = "";

  save(): void {
    const versionNumber = parseInt(this.version.replace("V", ""), 10);
    this.pendingSaveVersion = this.version ?? `V${versionNumber + 1}`;
    this.showConfirmPopup = true; // show the popup
  }

  // Called when user clicks "Yes" or "No"
  onConfirm(confirmed: boolean): void {
    this.showConfirmPopup = false;

    const updatedModel = {
      headingPageObj: this.headingPageObj,
      whatPageObj: this.whatPageObj,
      extraHeadingPageObj: this.extraHeadingPageObj,
      whyparaPageObj: this.whyparaPageObj,
      howPageObj: this.howPageObj,
      communityPageObj: this.communityPageObj,
      version: this.pendingSaveVersion,
      userEmail: this.userData.partitionKey,
      isCurrentAboutUs: confirmed, // true or false based on user's answer
    };

    console.log("Saving all updated content:", updatedModel);

    const data = this.flowServiceService
      .createAboutUs(updatedModel)
      .subscribe((data) => {
        console.log(data);
      });
    console.log(data);
    this.toastManager.success(
      `Version ${this.version} of the About Us page has been saved successfully.`
    );

    this.editingKeys.clear(); // Reset edit mode after save
  }

  createNewVersion() {
    // Generate new version name (e.g., v1, v2, v3...)
    let index = 1;
    let newVersion = `v${index}`;

    // Ensure the new version is unique
    while (this.versionList.includes(newVersion)) {
      index++;
      newVersion = `v${index}`;
    }

    // Add the unique new version
    this.versionList.push(newVersion);

    // Sort the versionList (by version number)
    this.versionList.sort((a, b) => {
      const numA = parseInt(a.replace(/\D/g, ""), 10);
      const numB = parseInt(b.replace(/\D/g, ""), 10);
      return numA - numB;
    });

    // Set it as the selected version
    this.version = newVersion;

    this.toastManager.success(
      `Created and switched to new version: ${newVersion}`
    );
  }

  async selectFiles(event: any, source: string) {
    if (event.target.files) {
      this.noResultReturned = true;
      this.fileData = <File>event.target.files[0];
      this.isLoading = true;
      // File type detection
      const imageExtensions = [
        "jpeg",
        "jpg",
        "png",
        "gif",
        "jfif",
        "tiff",
        "tif",
        "pdf", // From your list, normalized
        "bmp",
        "webp",
        "svg",
        "heic",
        "heif",
        "raw",
        "arw",
        "cr2",
        "nef",
        "orf",
        "rw2",
        "dng",
        "psd",
        "ico",
        "exif",
        "pjpeg",
        "ppm",
        "pgm",
        "pbm",
        "pnm",
        "xpm",
        "tga",
        "pcx",
        "jp2",
        "jpx",
        "eps",
        "ai",
      ];
      const videoExtensions = [
        "mp4",
        "mov",
        "wmv",
        "flv",
        "avchd",
        "webm",
        "mkv",
        "vob", // From your list
        "ogv",
        "gifv",
        "m4p",
        "m4v",
        "3gp",
        "3g2",
        "amv",
        "nsv",
        "ogg",
        "f4v",
        "f4p",
        "f4a",
        "f4b", // From your list
        "avi",
        "mts",
        "m2ts",
        "ts",
        "mpg",
        "mpeg",
        "rm",
        "rmvb",
        "divx",
        "xvid",
        "asf",
        "mxf",
        "dv",
        "h264",
        "h265",
        "vp8",
        "vp9",
        "prores",
        "swf",
        "dat",
        "bik",
        "av1",
        "vro",
        "svi",
      ];

      const isImageOrPdf = imageExtensions.some((ext) =>
        this.fileData.name.includes(ext)
      );
      const isVideo = videoExtensions.some((ext) =>
        this.fileData.name.includes(ext)
      );

      let fileToUpload = this.fileData;
      if (isVideo) {
        try {
          fileToUpload = await this.mediaUploadService.prepareFileForUpload(this.fileData);
          this.fileData = fileToUpload;
        } catch (error: any) {
          this.isLoading = false;
          this.noResultReturned = false;
          this.fileName = "";
          this.toastManager.warning(error?.message || this.mediaUploadService.uploadTooLargeMessage());
          return;
        }
      }

      const formData = new FormData();
      formData.append("fileData", fileToUpload);

      const uploadUrl = isImageOrPdf
        ? environment.apiBaseUrl + environment.uploadImageUrl
        : environment.apiBaseUrl + environment.uploadVideoUrl;

      this.http
        .post(uploadUrl, formData, {
          reportProgress: true,
          observe: "events",
        })
        .subscribe(
          (event: HttpEvent<any>) => {
            switch (event.type) {
              case HttpEventType.UploadProgress:
                if (event.total) {
                  this.progress = Math.round(
                    (event.loaded / event.total) * 100
                  );
                }
                break;
              case HttpEventType.Response:
                this.handleFileUpload(event.body, isImageOrPdf, source);
                break;
            }
          },
          (error) => {
            this.isLoading = false;
            this.noResultReturned = false;
            this.fileName = "";
            this.toastManager.warning(this.mediaUploadService.uploadTooLargeMessage());
            console.error("Upload error:", error);
          }
        );
    }
  }

  handleFileUpload(response: any, isImageOrPdf: boolean, source: string) {
    this.isLoading = false;
    this.noResultReturned = false;
    const mediaUploadStatus = response;

    if (mediaUploadStatus) {
      if (isImageOrPdf) {
        this.showImage = true;
        this.showVideo = false;
        if (source === "cp") {
          this.fileName = this.fileData.name;
          this.coverPageURI =
            environment.imageStorageBaseUrl + mediaUploadStatus.fileName;
          this.whatPageObj.imageUrl = this.coverPageURI;
        } else if (source === "sd") {
          this.sffilename = mediaUploadStatus.fileName;
        }
      } else {
        this.showVideo = true;
        this.showImage = false;
        if (source === "cp") {
          this.fileName = this.fileData.name;
          this.coverPageURI =
            environment.videoStorageBaseUrl + mediaUploadStatus.fileName;
          this.howPageObj.videoUrl = this.coverPageURI;
          this.coverPosterPageURI =
            environment.imageStorageBaseUrl + mediaUploadStatus.posterImageName;
        } else if (source === "sd") {
          this.sffilename = mediaUploadStatus.fileName;
        }
      }
      this.toastManager.success("File has been uploaded successfully.");
      this.progress = 100;
    } else {
      this.toastManager.error("Upload failed");
    }
  }
}
